import React from 'react';
import { Container } from 'react-bootstrap';

import Header from './Header';
import Footer from './Footer';


const MAX_BODY_WIDTH = 915;
const HEADER_HEIGHT = 61;

const PageWrapper = ({ children, isMobile, topId, width, height, fadeStyle, showHeaderLogo = false, foo = false, maxWidth }) => {

  return (
    <div 
    id="top"
    style={{
      height: '100%',
      minHeight: height,
      // border: '1px solid blue',
      paddingTop: HEADER_HEIGHT
    }}
    >
      {fadeStyle && <div
       className='homepageFade' 
       style={{
        height: height,
        // border: '1px solid yellow',
        zIndex: -1,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
      }} />}
      <Header MAX_BODY_WIDTH={maxWidth || MAX_BODY_WIDTH} HEADER_HEIGHT={HEADER_HEIGHT} width={width} showHeaderLogo={showHeaderLogo} foo={foo} transparentHeader={fadeStyle} isMobile={isMobile}/>
      <main

        style={{
          width: '100%',
          // minHeight: height,
          // height: '100%',
          // border: '1px solid green',
          position: 'block',
          top: 0,
          zIndex: 1,
        }}>
        <div
          style={{
            // width: '100%',
            display: 'flex',
            height: '100%',
            // border: '1px solid red',
            // justifyContent: 'center',
            alignItems: 'center',
            marginRight: 40,
            marginLeft: 40,
            // marginTop: HEADER_HEIGHT,
            // minHeight: height - 268,
          }}
        >
          <Container
            fluid
            nogutters="true"
            style={{
              maxWidth: maxWidth || MAX_BODY_WIDTH,
              padding: 0,
              // border: '1px solid purple',
            }}
          >
            {children}
          </Container>
        </div>
      </main>
      <Footer MAX_BODY_WIDTH={maxWidth || MAX_BODY_WIDTH} width={width} />
    </div>
  )
}

export default PageWrapper;